import { createAsyncThunk } from '@reduxjs/toolkit';

import { ITopic } from '.';
import { ApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider from '../../dataProvider/APIDataProvider';
import { IGroupedTopic } from '../SubTopicSlice';

interface IGetTopics {
  curriculum: string;
  subject: string;
  subjectCode?: string;
  subjectLevel?: string;
}

const TopicApiDataProvider = new APIDataProvider<ITopic>();
const TopicWithSubTopicApiDataProvider = new APIDataProvider<IGroupedTopic[]>();

export const getTopics = createAsyncThunk(
  'topics/list',
  async (data: { subjectCode: string; subjectLevel: string }) => {
    const response = await TopicApiDataProvider.get(
      `${ApiPaths.topics}?subjectCode=${data.subjectCode}&subjectLevel=${data.subjectLevel}`
    );

    return response.data as Array<ITopic>;
  }
);

export const getTopicsWithSubTopics = createAsyncThunk(
  'topics/getTopics',
  async (data: IGetTopics) => {
    const response = await TopicWithSubTopicApiDataProvider.create(
      `${ApiPaths.topics}/getTopics`,
      data
    );

    return response.data as Array<IGroupedTopic>;
  }
);

export const getTopicsBySubjectData = createAsyncThunk(
  'topics/getTopicsBySubjectData',
  async (data: { curriculum: string; subject?: string }) => {
    let path = `${ApiPaths.topics}/getTopicsBySubjectData?curriculum=${data.curriculum}`;

    if (data.subject) {
      path += `&subject=${data.subject}`;
    }

    const response = await TopicApiDataProvider.get(path);

    return response.data as Array<ITopic>;
  }
);
